import { render, staticRenderFns } from "./SuperAdminPdfStorageSettings.vue?vue&type=template&id=7db0428b&scoped=true"
import script from "./SuperAdminPdfStorageSettings.vue?vue&type=script&lang=js"
export * from "./SuperAdminPdfStorageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db0428b",
  null
  
)

export default component.exports